export const sidebarWidth = 300
export const navbarHeight = 60



// WEBPACK FOOTER //
// ./src/utils/sizes.js